/**
 * Auth Configuration Constants
 * Defines session lifetimes, token TTLs, cookie settings, and OAuth providers
 */

export const AUTH_CONFIG = {
  SESSION_COOKIE_NAME: 'sb-session',
  ACCESS_TOKEN_TTL: 3600, // 1 hour in seconds
  REFRESH_TOKEN_TTL: 604800, // 7 days in seconds
  MAX_SESSION_LIFETIME: 2592000, // 30 days in seconds
  MAGIC_LINK_EXPIRY: 300, // 5 minutes in seconds
  OAUTH_PROVIDERS: ['google', 'github'] as const,
  AUTH_CALLBACK_PATH: '/auth/callback',
  LOGIN_PATH: '/login',
  DASHBOARD_PATH: '/dashboard',
  COOKIE_OPTIONS: {
    httpOnly: true,
    secure: true,
    sameSite: 'lax' as const,
    path: '/',
    maxAge: 604800, // 7 days
  },
} as const;

export type OAuthProvider = (typeof AUTH_CONFIG.OAUTH_PROVIDERS)[number];
